import React from "react";
import AddMobile from "../../components/form/AddMobile";

const AddProduct = () => {
  return (
    <div className="min-h-screen mt-8">
      <AddMobile />
    </div>
  );
};

export default AddProduct;
